// Created By Masood Torabi on 12/18/2019
import BaseApiService from "services/http/baseService";

class Settlement extends BaseApiService {
	constructor() {
		super("settlements");
	}

	public request(amount: number): HttpService.BaseResponse<SettlementType> {
		return this.getResource().get(`/request-settlement/${amount}`);
	}

	public requestBySheba(data: Settlement.RequestBySheba): HttpService.BaseResponse<SettlementType> {
		return this.getResource().post("request-settlement-by-sheba", data);
	}
}

const SettlementService = new Settlement();

export enum SettlementStatus {
	TODO = "TODO",
	IN_PROGRESS = "IN_PROGRESS",
	FAIL = "FAIL",
	UNKNOWN = "UNKNOWN",
	DONE = "DONE",
	INVALID_SHEBA = "INVALID_SHEBA",
	SUSPICIOUS = "SUSPICIOUS",
}

export type SettlementType = {
	id: string;
	userId: string;
	settlementsId: string;
	amount: number;
	description: string;
	bankShabaNumber: string;
	createdDate: number;
	closeDate: number;
	lastModifiedDate: number;
	settlementStatus: SettlementStatus;
};

export default SettlementService;
